import { render, staticRenderFns } from "./actions-column.vue?vue&type=template&id=ff04d8a6"
import script from "./actions-column.vue?vue&type=script&lang=js"
export * from "./actions-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff04d8a6')) {
      api.createRecord('ff04d8a6', component.options)
    } else {
      api.reload('ff04d8a6', component.options)
    }
    module.hot.accept("./actions-column.vue?vue&type=template&id=ff04d8a6", function () {
      api.rerender('ff04d8a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/database/actions-column.vue"
export default component.exports